$(document).ready(function(){

	var $fbslide = $('.facebookstream--slide');

	$fbslide.slick({
		prevArrow: '<button type="button" class="slick-prev"><span class="sr-only">Vorheriges</span></button>',
		nextArrow: '<button type="button" class="slick-next"><span class="sr-only">Nächstes</span></button>',
		slidesToShow : 1,
		slidesToScroll: 1,
		arrows : false,
		dots: true,
		slide : '.facebookstream--item',
		adaptiveHeight: false,
		fade: false,
		speed: 500,
		autoplay : false,
		autoplaySpeed : 5000
	});
	
});